import { ro } from "../../../../date-fns/locale/ro.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ro
  }
};